import { render, staticRenderFns } from "./Concurrencies.vue?vue&type=template&id=2485cbd4&scoped=true"
import script from "./Concurrencies.vue?vue&type=script&setup=true&lang=js"
export * from "./Concurrencies.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Concurrencies.vue?vue&type=style&index=0&id=2485cbd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2485cbd4",
  null
  
)

export default component.exports